import { Message } from '@/types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import 'highlight.js/styles/github.css';

interface MessageListProps {
  messages: Message[];
}

export default function MessageList({ messages }: MessageListProps) {
  if (!messages || messages.length === 0) {
    return (
      <div role="list" className="message-list empty">
        <p>No messages yet. Start a conversation!</p>
      </div>
    );
  }

  return (
    <div role="list" className="message-list">
      {messages.map((message) => (
        <div
          key={message.id}
          role="listitem"
          className={`message ${message.role === 'user' ? 'message-user' : 'message-assistant'}`}
        >
          <div className="message-header">
            <span className="message-role">
              {message.role === 'user' ? 'You' : 'Agent'}
            </span>
            <span className="message-time">
              {new Date(message.timestamp).toLocaleTimeString()}
            </span>
          </div>
          <div className="message-content">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeHighlight]}
            >
              {message.content}
            </ReactMarkdown>
          </div>
          {message.toolCalls && message.toolCalls.length > 0 && (
            <div className="tool-calls">
              {message.toolCalls.map((toolCall) => (
                <div key={toolCall.id} className="tool-call">
                  <strong>Tool: {toolCall.function.name}</strong>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
